// extracted by mini-css-extract-plugin
module.exports = {"container":"e_1o","card":"e_2o","wideContainer":"e_3o","containerHollow":"e_4o"};